import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const PasswordValidation = ({ password, isValidPassword }) => {
    const [conditions, setConditions] = useState({
        hasNumber: false,
        hasValidLength: false,
        hasSpecialChar: false
    });

    useEffect(() => {
        const conditionsUpdated = {
            hasNumber: /\d/.test(password),
            hasValidLength: password.length >= 10 && password.length <= 12,
            hasSpecialChar: /[!@#$%^&*(),.?":{}|<>\s]/.test(password)
        };
        setConditions(conditionsUpdated);

        const { hasNumber, hasValidLength, hasSpecialChar } = conditionsUpdated;
        if (!password) isValidPassword(true)
        else isValidPassword(hasNumber && hasValidLength && hasSpecialChar);
    }, [password, isValidPassword]);

    return (
        <ul className="d-inline p-0">
            {[
                { label: "Un caracter especial", validationKey: "hasSpecialChar" },
                { label: "Al menos un número", validationKey: "hasNumber" },
                { label: "Entre 10 y 12 caracteres", validationKey: "hasValidLength" },
            ].map((item, index) => (
                <span key={item.validationKey} className="d-block flex-direction-row">
                    <i
                        className={`d-inline mdi ${conditions[item.validationKey]
                            ? "mdi-checkbox-marked-circle-outline color-verde-megatone"
                            : "mdi-minus-circle-outline color-rojo-megatone"
                            }`
                        }
                        style={{ transition: "0.3s ease" }}
                    />
                    <li className="d-inline ms-1">{item.label}</li>
                </span>
            ))}
        </ul>
    );
};
PasswordValidation.propTypes = {
    password: PropTypes.string,
    isValidPassword: PropTypes.func,
}

export default PasswordValidation;